module.exports = __webpack_public_path__ + "img/logo-haute-route.e9b96f9b.svg";